module.exports = __webpack_public_path__ + "static/media/icon_208.6ceeff28.svg";